import { render, staticRenderFns } from "./notification-support.vue?vue&type=template&id=6f72743c&scoped=true&"
import script from "./notification-support.vue?vue&type=script&lang=js&"
export * from "./notification-support.vue?vue&type=script&lang=js&"
import style0 from "./notification-support.vue?vue&type=style&index=0&id=6f72743c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72743c",
  null
  
)

export default component.exports